export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6980.6215488d.jpg";